import React from 'react';
import { Link } from 'react-router-dom';
import {
    LuPhone,
    LuMail,
    LuMapPin,
    LuBookOpen,
    LuFacebook,
    LuInstagram,
    LuTwitter,
} from "react-icons/lu";
import { SiTiktok } from "react-icons/si";
import utils from '../../utils';

function Footer() {
    const currentYear = new Date().getFullYear();

    function openModal() {
        const openBtn = document.getElementById("contact-modal-open-btn");
        if (openBtn) openBtn.click();
    }

    return (
        <footer className="bg-surface-container border-t border-outline-variant/30 pt-20 px-3">
            <div className="container mx-auto pb-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

                    <div className="space-y-6">
                        <h2 className="text-2xl font-black text-primary uppercase tracking-tighter">
                            {utils.siteName}
                        </h2>
                        <p className="text-on-surface-variant text-sm leading-relaxed">
                            Expert architectural consulting and construction management in Nairobi.
                            Turning complex visions into structural reality.
                        </p>
                        <div className="flex gap-4">
                            <a href="https://web.facebook.com/profile.php?id=100095247722829" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-lg bg-surface-container-lowest flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all">
                                <LuFacebook size={20} />
                            </a>
                            <a href="https://x.com/Jahtech_consult" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-lg bg-surface-container-lowest flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all">
                                <LuTwitter size={20} />
                            </a>
                            <a href="https://www.instagram.com/jahtech_construction/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-lg bg-surface-container-lowest flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all">
                                <LuInstagram size={20} />
                            </a>
                            <a href="https://www.tiktok.com/@jahtechconsult" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-lg bg-surface-container-lowest flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all">
                                <SiTiktok size={20} />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="font-bold text-on-surface mb-6 uppercase tracking-widest text-xs">Important Links</h4>
                        <ul className="space-y-4 text-sm text-on-surface-variant font-medium">
                            <li><Link to="/" className="hover:text-primary transition-colors">Home</Link></li>
                            <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
                            <li><Link to="/houses" className="hover:text-primary transition-colors">House Plans</Link></li>
                            <li><Link to="/blog" className="hover:text-primary transition-colors">Construction Blog</Link></li>
                            <li><span onClick={openModal} className="hover:text-primary transition-colors cursor-pointer">Custom Assessment</span></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-on-surface mb-6 uppercase tracking-widest text-xs">Contact Info</h4>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3">
                                <LuPhone className="text-primary mt-1" />
                                <div className="text-sm">
                                    <p className="font-bold text-on-surface">Call Us</p>
                                    <a href="tel:+254108455455" className="text-on-surface-variant hover:text-primary">+254 108 455 455</a>
                                </div>
                            </li>
                            <li className="flex items-start gap-3">
                                <LuMail className="text-primary mt-1" />
                                <div className="text-sm">
                                    <p className="font-bold text-on-surface">Email</p>
                                    <a href="mailto:info@jahtechconstruction.co.ke" className="text-on-surface-variant hover:text-primary">info@jahtechconstruction.co.ke</a>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-on-surface mb-6 uppercase tracking-widest text-xs">Headquarters</h4>
                        <ul className="space-y-4">
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href="https://www.google.com/maps/dir//JAHTECH+CONSTRUCTION+CONSULTANTS,+Feruzi+Towers,+Kiambu+Rd/@-1.2288,36.7034368,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x182f3d612fcc5765:0x93a582971d07a76e!2m2!1d36.833523!2d-1.2038341?entry=ttu&g_ep=EgoyMDI2MDUwMi4wIKXMDSoASAFQAw%3D%3D">
                                <li className="flex items-start gap-3">
                                    <LuMapPin className="text-primary mt-1" />
                                    <div className="text-sm">
                                        <p className="font-bold text-on-surface">Office</p>
                                        <p className="text-on-surface-variant">Feruzi Towers, Kiambu Rd.</p>
                                    </div>
                                </li>
                            </a>
                            <li className="flex items-start gap-3">
                                <LuBookOpen className="text-primary mt-1" />
                                <div className="text-sm">
                                    <p className="font-bold text-on-surface">Address</p>
                                    <p className="text-on-surface-variant">P.O Box 56415-00200<br />Nairobi, Kenya</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-outline-variant/20 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-on-surface-variant font-medium">
                        © {currentYear} {utils.siteName}. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;